import NavFooter from './nav-footer'

export default NavFooter
